import { API } from '@/utils'
import clinicValidator from '@/utils/clinicValidator'

export default {
    state: {
        clinics: [],
        clinic: {},
        status: 'ready'
    },
    mutations: {
        SET_IS_PUBLISH(state, payload) {
            const updateClinic = state.clinics.find(value => value.id == payload.id)
            updateClinic.isPublished = payload.isPublished
        },

        LOADING(state) {
            state.status = 'loading'
        },

        READY(state) {
            state.status = 'ready'
        },

        LOAD_ALL_CLINICS(state, payload) {
            const clinics = clinicValidator(payload)
            state.clinics = clinics
        },
    },
    actions: {
        ADD_NEW_CLINIC({ commit, dispatch }, payload) {
          return new Promise((resolve, reject) => {
              API.post(`/clinics/`, payload.clinic)
                  .then(response => {
                      dispatch('LOAD_ALL_CLINICS')
                      resolve('Успешно сохранено')
                  })
                  .catch( e => {
                      reject(e)
                  })
          })
      },
        SET_IS_PUBLISH({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                API.patch(`/clinics/${payload.id}`, {
                    isActive: payload.isActive
                })
                .then(response => {
                    dispatch('LOAD_ALL_CLINICS')
                    resolve('Успешно сохранено')
                })
                .catch(e => {
                    throw e
                })
            })
        },
        SAVE_MAIN_DATA_CHANGES({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                API.patch(`/clinics/${payload.id}`, payload.clinic)
                    .then(response => {
                        dispatch('LOAD_ALL_CLINICS')
                        resolve('Успешно сохранено')
                    })
                    .catch( e => {
                        reject(e)
                    })
            })
        },
        SAVE_OMS_ID({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                API.patch(`/clinics/${payload.id}`, payload.clinic)
                    .then(() => {
                        dispatch('LOAD_ALL_CLINICS')
                        resolve('Успешно сохранено')
                    })
                    .catch( e => {
                        reject(e)
                    })
            })
        },

        SAVE_NETRIKA_ID({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                API.patch(`/clinics/${payload.id}`, payload.netrika)
                    .then(() => {
                        dispatch('LOAD_ALL_CLINICS')
                        resolve('Успешно сохранено')
                    })
                    .catch( e => {
                        reject(e)
                    })
            })
        },

        SAVE_META_DATA_CHANGES({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                API.patch(`/clinics/${payload.id}/meta`, payload.meta)
                .then(() => {
                    dispatch('LOAD_ALL_CLINICS')
                    resolve('Успешно сохранено')
                })
                .catch(e => {
                    reject(e)
                })
            })
            
        },
        LOAD_ALL_CLINICS({ commit }) {
            API.get('/clinics')
                .then(response => {
                    commit('LOAD_ALL_CLINICS', response.data)
                })
                .catch(e => {
                    throw e
                })
        },
        LOAD_CLINIC_BY_ID({commit}, id) {
            API.get(`/clinics/${id}`)
                .then(response => {
                    commit('LOAD_ALL_CLINICS', response.data)
                })
                .catch(e => {
                    throw e
                })
        }
    },
    getters: {
        GET_CLINICS(state) {
            return state.clinics
        },
        GET_LOADING_STATUS(state) {
            return state.status
        },
        GET_CLINIC_PROPERTY(state) {
            return (id, prop) => {
                return state.clinics.find(v => v.id === id)[prop]
            }
        },
        getClinicInfo(state) {
            return id => state.clinics.find((item) => item.id === id)
        },
    }
}
